import { Link } from "react-router-dom";
import { routes } from "routes";
import React from "react";

export const FileMimeTypeError = () => (
  <div>
    File type not supported.<br />
    Unfortunately we do not support the file type you are attempting to upload.<br />
    Our Uploading requirements and rules can be found <Link to={routes.faq()}>here</Link>.
  </div>
);
